import {action, makeObservable, observable} from "mobx";

import {AdminApi} from "../../../api/api";
import {Stores} from "../../../stores";
import {SimpleToast} from "../../../stores/toast-store";

interface TagDeleteStoreOptions {
    mediaId: string;
    adminApi: AdminApi;
    stores: Stores;
}

export class TagDeleteStore {
    @observable
    public mediaId: string = "";

    @observable
    public label: string = "";

    @observable
    public slug: string = "";

    @observable
    public isOpen = false;

    private adminApi: AdminApi;
    private stores: Stores;

    constructor(options: TagDeleteStoreOptions) {
        this.adminApi = options.adminApi;
        this.stores = options.stores;
        this.mediaId = options.mediaId;

        makeObservable(this);
    }

    @action.bound
    public async open(label: string, slug: string) {
        this.isOpen = true;
        this.label = label;
        this.slug = slug;
    }

    @action.bound
    public async close() {
        this.isOpen = false;
    }

    @action.bound
    public async delete() {
        try {
            await this.adminApi.deleteTag({mediaId: this.mediaId}, {key: this.slug});
            this.stores.toastStore.setSimpleToast(SimpleToast.DELETED);
            this.stores.toastStore.keepFirstRouteChange();
        } catch (e) {
            console.error(e);
        } finally {
            this.close();
        }
    }
}
